import type { FieldListItem } from '#blokkli/types'
import type {
  ParagraphFragment,
  ParagraphTeaserFragment,
} from '#build/graphql-operations'

export type TeaserColumns = 'fifth' | 'quarter' | 'third' | 'half' | 'full'

type ParagraphBundleTypeMap = {
  teaser: ParagraphTeaserFragment
}

export function getParagraphOfBundle<
  K extends keyof ParagraphBundleTypeMap,
  Type = ParagraphBundleTypeMap[K],
>(item: FieldListItem | null, bundle: K): Type | null {
  if (!item) {
    return null
  }
  const itemProps = item.props as ParagraphFragment | null
  if (!itemProps) {
    return null
  }

  if ('libraryItem' in itemProps) {
    const nested = itemProps.libraryItem?.block
    if (nested && nested.bundle === bundle) {
      return nested.props as Type
    }
  }

  if (item.bundle === bundle) {
    return itemProps as Type
  }
  return null
}
